import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addSingleBlog, blogList, changeSingleBlogStatus, deleteSingleBlog, updateSingleBlog } from "../apis/apiHandler";

export const blogs = createAsyncThunk(
    "blog/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await blogList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addBlog = createAsyncThunk(
    "blog/add",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await addSingleBlog(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateBlog = createAsyncThunk(
    "blog/update",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await updateSingleBlog(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteBlog = createAsyncThunk(
    "blog/delete",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteSingleBlog(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const changeBlogStatus = createAsyncThunk(
    "blog/changeStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await changeSingleBlogStatus(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    blogList: [],
    addBlogData: {},
    updateBlogData: {},
    deleteBlogData: {},
    changeBlogStatusData: {},
    error: null,
    success: false,
};

const blogSlice = createSlice({
    name: "blog",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(blogs.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(blogs.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.blogList = payload;
                state.success = true;
            })
            .addCase(blogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addBlog.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addBlog.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addBlogData = payload;
                state.success = true;
            })
            .addCase(addBlog.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(updateBlog.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(updateBlog.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.updateBlogData = payload;
                state.success = true;
            })
            .addCase(updateBlog.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(deleteBlog.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(deleteBlog.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.deleteBlogData = payload;
                state.success = true;
            })
            .addCase(deleteBlog.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(changeBlogStatus.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(changeBlogStatus.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.changeBlogStatusData = payload;
                state.success = true;
            })
            .addCase(changeBlogStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default blogSlice.reducer;
